<div class="form-group">
  <label *ngIf="label">{{ label }}</label>

  <div *ngIf="type !== 'textarea'" class="input-wrapper">
    <input
      nbInput
      fullWidth
      [type]="inputType"
      [disabled]="disabled"
      [value]="value"
      [attr.dir]="inputDir"
      [class.ltr-value]="inputDir === 'ltr'"
      [class.price-value]="!!displayUnit"
      (input)="onInput($event)"
      (blur)="onTouched()"
      [placeholder]="placeholder"
      [attr.autocomplete]="autocomplete || inputAttrs?.autocomplete"
      [attr.readonly]="readonlyAttr"
      [attr.maxlength]="inputAttrs?.maxlength"
      [attr.minlength]="inputAttrs?.minlength"
      [attr.min]="inputAttrs?.min"
      [attr.max]="inputAttrs?.max"
      [attr.step]="inputAttrs?.step"
      [attr.pattern]="inputAttrs?.pattern"
    />
    <span *ngIf="displayUnit" class="price-unit">{{ displayUnit }}</span>
  </div>

  <textarea
    *ngIf="type === 'textarea'"
    nbInput
    fullWidth
    rows="3"
    [disabled]="disabled"
    [value]="value"
    [attr.dir]="textareaDir"
    [class.ltr-value]="textareaDir === 'ltr'"
    (input)="onInput($event)"
    (blur)="onTouched()"
    [placeholder]="placeholder"
    [attr.autocomplete]="autocomplete || inputAttrs?.autocomplete"
    [attr.readonly]="readonlyAttr"
    [attr.maxlength]="inputAttrs?.maxlength"
    [attr.minlength]="inputAttrs?.minlength"
    [attr.min]="inputAttrs?.min"
    [attr.max]="inputAttrs?.max"
    [attr.step]="inputAttrs?.step"
    [attr.pattern]="inputAttrs?.pattern"
  ></textarea>
  <!-- status="danger"  -->

  <!-- Required error -->
  <ngx-error-field [control]="control" [label]="label"></ngx-error-field>
</div>
